import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from 'src/app/models/user';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  // Base url
  baseurl = environment.apiBase;
  constructor(private http: HttpClient) { }
  // POST
  authenticate(data: any): Observable<User> {
    return this.http
      .post<User>(
        this.baseurl + '/externals/Authenticate/',
        JSON.stringify(data)
      )
      .pipe();
  }
}